import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, distinctUntilChanged } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class ZoomService {
    constructor (
        private http: HttpClient,
    ) {}

    request (token:string, obj: Object, suffix: string, partnerid: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ngsw-bypass': '',
                'x-access-token': token,
                'x-access-partnerid': partnerid,
            })
        };
        return this.http.post('api/' + suffix, obj, httpOptions)
            .pipe(
                distinctUntilChanged(),
                catchError(res => of(res))
            );
    }
}
